export enum AddressType {
  BUS = 'BUS',
  RES = 'RES',
  HWRK = 'HWRK',
}

export type SlaT = string | null | undefined;
